import AvatarUser from './AvatarUser'

export default AvatarUser
